export default __webpack_public_path__ + "static/media/wsbg.bded4f44.png";